import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import store from './store.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGitlab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faGitlab)

Vue.config.productionTip = false

let vm = new Vue({
  render: h => h(App),
  store
}).$mount('#app')

// Dynamically loading theme style
require(`../${process.env.VUE_APP_THEMES_DIR}/${process.env.VUE_APP_THEME}/style.css`)

if (process.env.VUE_APP_API_CLIENT === 'mock') {
  require('./assets/mock-ribbon.css')
}

export default {
  showError(message) {
    vm.$bvToast.toast(message, {
      title: 'Error',
      variant: 'danger',
      solid: true
    });
  }
}
